//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.type

import com.apollographql.apollo.api.EnumType
import kotlin.Array
import kotlin.Deprecated
import kotlin.String
import kotlin.collections.List

public enum class InspectionTemplateStatus(
  public val rawValue: String,
) {
  DRAFT("DRAFT"),
  PUBLISHED("PUBLISHED"),
  /**
   * Auto generated constant for unknown enum values
   */
  UNKNOWN__("UNKNOWN__"),
  ;

  public companion object {
    public val type: EnumType = EnumType("InspectionTemplateStatus", listOf("DRAFT", "PUBLISHED"))

    /**
     * All [InspectionTemplateStatus] known at compile time
     */
    public val knownEntries: List<InspectionTemplateStatus>
      get() = listOf(
        InspectionTemplateStatus.DRAFT,
        InspectionTemplateStatus.PUBLISHED)

    /**
     * Returns all [InspectionTemplateStatus] known at compile time
     */
    @Deprecated(
      message = "Use knownEntries instead",
      replaceWith = ReplaceWith("this.knownEntries"),
    )
    public fun knownValues(): Array<InspectionTemplateStatus> = knownEntries.toTypedArray()

    /**
     * Returns the [InspectionTemplateStatus] that represents the specified [rawValue].
     * Note: unknown values of [rawValue] will return [UNKNOWN__]. You may want to update your schema instead of calling this function directly.
     */
    public fun safeValueOf(rawValue: String): InspectionTemplateStatus = entries.find { it.rawValue == rawValue } ?: UNKNOWN__
  }
}
